<script setup lang="ts">
// スウォッチ: 色の一覧。クリックで描画色、Alt+クリックで背景色、右クリックで削除。localStorage に保存。
import { ref, watch } from 'vue'
import { useUiStore } from '@/stores/uiStore'
import { useI18n } from '@/i18n'

const ui = useUiStore()
const { t } = useI18n()
const KEY = 'bpe.swatches.v1'
const DEFAULTS = ['#000000', '#ffffff', '#808080', '#c0c0c0', '#ff0000', '#ff8000', '#ffff00', '#80ff00', '#00ff00', '#00ff80', '#00ffff', '#0080ff', '#0000ff', '#8000ff', '#ff00ff', '#ff0080', '#800000', '#804000', '#808000', '#008000', '#008080', '#000080', '#800080', '#f5d0a9', '#e0ac69', '#8d5524', '#4f9cf5', '#e5484d']
function load(): string[] {
  try {
    const raw = localStorage.getItem(KEY)
    const v = raw ? (JSON.parse(raw) as unknown) : null
    if (Array.isArray(v) && v.every(x => typeof x === 'string' && /^#[0-9a-f]{6}$/i.test(x))) return v as string[]
  } catch {
    /* ignore */
  }
  return [...DEFAULTS]
}
const swatches = ref<string[]>(load())
watch(swatches, v => {
  try {
    localStorage.setItem(KEY, JSON.stringify(v))
  } catch {
    /* ignore */
  }
}, { deep: true })
function pick(hex: string, e: MouseEvent) {
  if (e.altKey) ui.background = hex
  else ui.foreground = hex
}
function add() {
  const hex = ui.foreground.toLowerCase()
  if (!swatches.value.includes(hex)) swatches.value.push(hex)
}
function remove(i: number, e: MouseEvent) {
  e.preventDefault()
  swatches.value.splice(i, 1)
}
function reset() {
  swatches.value = [...DEFAULTS]
}
</script>

<template>
  <div class="panel">
    <div class="panel-title row"><span>{{ t('panel.swatches') }}</span><span class="spacer" /><button class="icon ghost" :title="t('swatches.add')" @click="add">＋</button></div>
    <div class="grid">
      <button v-for="(s, i) in swatches" :key="s + i" class="sw" :style="{ background: s }" :title="s" @click="pick(s, $event)" @contextmenu="remove(i, $event)" />
      <button class="sw add" :title="t('swatches.add')" @click="add">＋</button>
    </div>
    <div class="row foot"><span class="muted small">{{ t('swatches.hint') }}</span><span class="spacer" /><button class="ghost tiny" title="reset" @click="reset">↺</button></div>
  </div>
</template>

<style scoped>
.panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.grid {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  padding: 6px 8px;
  overflow: auto;
}
.sw {
  width: 18px;
  height: 18px;
  padding: 0;
  border: 1px solid var(--line-strong);
  border-radius: 2px;
  cursor: pointer;
}
.sw.add {
  background: transparent;
  color: var(--fg-2);
  font-size: 12px;
  line-height: 1;
}
.foot {
  padding: 0 8px 4px;
}
.small {
  font-size: 10px;
}
.tiny {
  width: 22px;
  height: 20px;
  padding: 0;
}
</style>
